// extracted by mini-css-extract-plugin
export default {"disclaimer":"Register_disclaimer__x1Xie","formFields":"Register_formFields__mHtHb"};